import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetActivityClassesOutdatedQueryVariables = Types.Exact<{
  activityId: Types.Scalars['String'];
  isNotOlder: Types.Scalars['Boolean'];
}>;

export type GetActivityClassesOutdatedQuery = {
  __typename?: 'Query';
  ActivityWithOutdatedClasses: {
    __typename?: 'ActivityRespond';
    spots: number;
    sorted_classes?: Array<{
      __typename?: 'ActivityClassEntity';
      id: string;
      title: string;
      priceInCents: number;
      spots: number;
      start: any;
      booked: number;
      timelines: Array<{
        __typename?: 'TimelineEntity';
        id: string;
        timelineTeachers?: Array<{
          __typename?: 'TimelineTeacherEntity';
          createdDate?: any | null;
          deletedDate?: any | null;
          id: string;
          teacherId: string;
          timelineId: string;
          updatedDate?: any | null;
          teacher: {
            __typename?: 'MemberEntity';
            country?: string | null;
            email: string;
            id: string;
            name?: string | null;
            postcode?: string | null;
            roles: Array<string>;
            status: string;
            userId: string;
            avatar?: {
              __typename?: 'UserImageEntity';
              userId: string;
              updatedDate?: any | null;
              link: string;
              key: string;
              id: string;
              filename: string;
              deletedDate?: any | null;
              createdDate?: any | null;
            } | null;
          };
        }> | null;
      }>;
    }> | null;
  };
};

export const GetActivityClassesOutdatedDocument = gql`
  query GetActivityClassesOutdated(
    $activityId: String!
    $isNotOlder: Boolean!
  ) {
    ActivityWithOutdatedClasses(id: $activityId, isNotOlder: $isNotOlder) {
      sorted_classes {
        id
        title
        priceInCents
        spots
        start
        booked
        timelines {
          id
          timelineTeachers {
            createdDate
            deletedDate
            id
            teacherId
            timelineId
            updatedDate
            teacher {
              country
              avatar {
                userId
                updatedDate
                link
                key
                id
                filename
                deletedDate
                createdDate
              }
              email
              id
              name
              postcode
              roles
              status
              userId
            }
          }
        }
      }
      spots
    }
  }
`;

/**
 * __useGetActivityClassesOutdatedQuery__
 *
 * To run a query within a React component, call `useGetActivityClassesOutdatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityClassesOutdatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityClassesOutdatedQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      isNotOlder: // value for 'isNotOlder'
 *   },
 * });
 */
export function useGetActivityClassesOutdatedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivityClassesOutdatedQuery,
    GetActivityClassesOutdatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActivityClassesOutdatedQuery,
    GetActivityClassesOutdatedQueryVariables
  >(GetActivityClassesOutdatedDocument, options);
}
export function useGetActivityClassesOutdatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivityClassesOutdatedQuery,
    GetActivityClassesOutdatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActivityClassesOutdatedQuery,
    GetActivityClassesOutdatedQueryVariables
  >(GetActivityClassesOutdatedDocument, options);
}
export type GetActivityClassesOutdatedQueryHookResult = ReturnType<
  typeof useGetActivityClassesOutdatedQuery
>;
export type GetActivityClassesOutdatedLazyQueryHookResult = ReturnType<
  typeof useGetActivityClassesOutdatedLazyQuery
>;
export type GetActivityClassesOutdatedQueryResult = Apollo.QueryResult<
  GetActivityClassesOutdatedQuery,
  GetActivityClassesOutdatedQueryVariables
>;
